import axios from "axios";
import React, {
  useEffect,
  useState,
  useContext,
  Fragment,
  useMemo,
} from "react";
import { Link, useHistory } from "react-router-dom";
import { Dialog, Transition } from "@headlessui/react";
import { Box, Button } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { ExclamationIcon } from "@heroicons/react/outline";
import UserDataContext from "../../context/UserDataContext";
import { MRT_Localization_DE } from "material-react-table/locales/de";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { translate } from "../../translations";

export default function OrderList() {
  const history = useHistory();
  const [orders, setOrders] = useState([]);
  const { userData } = useContext(UserDataContext);
  const [deleteOrder, setDeleteOrder] = useState({});
  const [openDelete, setOpenDelete] = useState(false);
  const token = localStorage.getItem("token");
  const project = localStorage.getItem("currentProjectID");
  var date = new Date();
  const [timePeriod, setTimePeriod] = useState({
    startDate: new Date(date.getFullYear(), date.getMonth(), 1, 3)
      .toISOString()
      .substr(0, 10),
    endDate: new Date(date.getFullYear(), date.getMonth() + 1, 1)
      .toISOString()
      .substr(0, 10),
  });

  async function getOrders() {
    const userRes = await axios.post(
      `${process.env.REACT_APP_BACKEND}/services/orders/list`,
      { project, startDate: timePeriod.startDate, endDate: timePeriod.endDate },
      {
        headers: {
          jwttoken: token,
        },
      }
    );

    setOrders(userRes.data);
    if (
      userData &&
      userData.permissions &&
      !userData.permissions[project].isProjectAdmin
    ) {
      console.log(userRes.data, userData);
      setOrders(
        userRes.data.filter((order) =>
          userData.permissions[project].kostenstellen.includes(
            order.service.kostenstelle._id
          )
        )
      );
    }
  }

  async function deleteOrderCall() {
    await axios.post(
      `${process.env.REACT_APP_BACKEND}/services/order/delete/${deleteOrder.id}`,
      { userData },
      {
        headers: {
          jwttoken: token,
        },
      }
    );
    setOpenDelete(false);
    history.go(0);
  }

  let columns = [
    {
      accessorKey: "status",
      header: "Status",
      muiTableBodyCellProps: ({ row }) => {
        if (row.original.status === "storniert") {
          return { sx: { backgroundColor: "#D3D3D3" } };
        }
        if (row.original.status === "erledigt") {
          return { sx: { backgroundColor: "#90EE90" } };
        }
        if (row.original.status === "reklamiert") {
          return { sx: { backgroundColor: "#FFCCCB" } };
        }
        if (row.original.status === "abgenommen") {
          return { sx: { backgroundColor: "#00c000" } };
        }
      },
    },
    {
      accessorKey: "service.pos_name",
      header: "Pos. Name",
    },
    {
      accessorKey: "service.pos_nr",
      header: "Pos. Nr.",
    },
    {
      accessorKey: "service.kostenstelle.name",
      header: "Kst.",
    },
    {
      accessorKey: "orderDate",
      header: "Datum",
      muiTableBodyCellProps: ({ row }) => {
        if (
          row.original.status === "offen" &&
          new Date(row.original.orderDate) < new Date()
        ) {
          return { sx: { backgroundColor: "#FFCCCB" } };
        }
      },
    },
    {
      accessorKey: "comment",
      header: "Kommentar",
    },
    {
      accessorKey: "_id",
      header: translate("optionen"),
      enableHiding: false,
      Cell: ({ cell, row }) => (
        <>
          <Link to={`/edit-order/${cell.getValue()}`}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="h-6 w-6 inline-block mr-2"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10"
              />
            </svg>
          </Link>
          {cell.row.original.active && (
            <a
              href="#"
              onClick={() => {
                setDeleteOrder({
                  id: cell.getValue(),
                });
                setOpenDelete(true);
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6 inline-block mr-2"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                />
              </svg>
            </a>
          )}
        </>
      ),
    },
  ];

  let table = useMaterialReactTable({
    columns,
    data: orders,
    enableGrouping: true,
    localization: MRT_Localization_DE,
    enableSelectAll: true,

    enableRowSelection: (row) => row.original.status === "offen",
    renderTopToolbarCustomActions: ({ table }) => (
      <Box
        sx={{
          display: "flex",
          gap: "16px",
          padding: "8px",
          flexWrap: "wrap",
        }}
      >
        <Button
          startIcon={<CheckCircleOutlineIcon />}
          onClick={async () => {
            const selectedRows = table.getSelectedRowModel().rows;
            let updateOrders = [];
            selectedRows.forEach((order) => {
              updateOrders.push(order.original._id);
            });
            const apiRes = await axios.post(
              `${process.env.REACT_APP_BACKEND}/services/orders/confirmMultiple`,
              updateOrders,
              {
                headers: {
                  jwttoken: token,
                },
              }
            );
            history.go(0);
          }}
        >
          Auswahl als "heute erledigt" markieren
        </Button>
      </Box>
    ),
    initialState: {
      columnOrder: [
        "status",
        "service.pos_name",
        "service.pos_nr",
        "service.kostenstelle.name",
        "orderDate",
        "comment",
        "_id",
      ],
      pagination: { pageSize: 25, pageIndex: 0 },
    },
    enableColumnOrdering: true,
    enableGlobalFilter: true,
  });

  useEffect(() => {
    getOrders();
  }, [timePeriod, userData, table.getState().rowSelection]);

  return (
    <>
      <div className="bg-white shadow overflow-hidden sm:rounded-lg flex justify-between">
        <div className="px-4 py-5 sm:px-6 justify-start lg:w-0 lg:flex-1">
          <h3 className="text-lg leading-6 font-medium text-gray-900">
            Bestellungen
          </h3>
          <p className="mt-1 max-w-2xl text-sm text-gray-500">
            Hier finden Sie eine Übersicht aller <b>aktiver</b> Bestellungen im
            ausgewählten Zeitraum.
          </p>
        </div>
        <div className="px-4 py-5 sm:px-6 flex justify-end md:flex-1 lg:w-0">
          <div class="flex">
            <span class="inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md ">
              Von:
            </span>
            <input
              type="date"
              required="true"
              onChange={(e) =>
                setTimePeriod({
                  ...timePeriod,
                  startDate: e.target.value,
                })
              }
              value={timePeriod.startDate}
              className="rounded-none rounded-e-lg bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5"
            />
          </div>

          <div class="ml-3 flex">
            <span class="inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md ">
              Bis:
            </span>
            <input
              type="date"
              required="true"
              onChange={(e) =>
                setTimePeriod({
                  ...timePeriod,
                  endDate: e.target.value,
                })
              }
              value={timePeriod.endDate}
              className="rounded-none rounded-e-lg bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5"
            />
          </div>
        </div>
      </div>
      <div className="bg-white w-full  shadow overflow-auto sm:rounded-lg flex justify-between my-5 border-b border-gray-200 shadow  w-full sm:rounded-lg"></div>
      <MaterialReactTable table={table} />
      {openDelete && (
        <Transition.Root show={openDelete} as={Fragment}>
          <Dialog as="div" className="relative z-10" onClose={setOpenDelete}>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </Transition.Child>

            <div className="fixed z-10 inset-0 overflow-y-auto">
              <div className="flex items-end sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  enterTo="opacity-100 translate-y-0 sm:scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                  leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                >
                  <Dialog.Panel className="relative bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-lg sm:w-full">
                    <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                      <div className="sm:flex sm:items-start">
                        <div className="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                          <ExclamationIcon
                            className="h-6 w-6 text-red-600"
                            aria-hidden="true"
                          />
                        </div>
                        <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                          <Dialog.Title
                            as="h3"
                            className="text-lg leading-6 font-medium text-gray-900"
                          >
                            Bestellung stornieren
                          </Dialog.Title>
                          <div className="mt-2">
                            <p className="text-sm text-gray-500">
                              Sind Sie sicher, dass Sie diese Bestellung
                              stornieren möchten?
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                      <button
                        type="button"
                        className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm"
                        onClick={deleteOrderCall}
                      >
                        Stornieren
                      </button>
                      <button
                        type="button"
                        className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                        onClick={() => setOpenDelete(false)}
                      >
                        Abbrechen
                      </button>
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition.Root>
      )}
    </>
  );
}
